import React from 'react';
import { Link } from 'react-router-dom';

const AboutCrystals = () => {
  return (
    <div className="container mx-auto px-4 py-6">
      <div className="bg-white bg-opacity-90 rounded-lg shadow-md p-6 md:p-8">
        <h1 className="text-3xl font-bold mb-6 text-center">关于水晶</h1>
        
        <div className="prose max-w-none">
          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">水晶的历史与起源</h2>
            <p>
              水晶在人类历史上有着悠久的地位，几乎所有古代文明都对水晶有着特殊的认知和使用。
              古埃及人使用水晶制作护身符，古希腊人相信水晶是永恒冰的化身，
              中国古代将水晶视为纯洁和权力的象征，而美洲原住民则将水晶用于治疗和仪式。
            </p>
            <p className="mt-4">
              水晶是地球经过数百万年地质活动形成的自然宝石，每种水晶都有其独特的矿物成分、
              晶体结构和能量特性。水晶不仅因其美丽的外观而受到珍视，更因其被认为具有的能量特性
              而在能量学和灵性实践中扮演重要角色。
            </p>
          </section>
          
          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">水晶能量学基础</h2>
            <p>
              水晶能量学基于这样一个理念：所有物质，包括水晶，都由振动的能量组成。
              每种水晶因其独特的分子结构和矿物成分，会产生特定频率的能量场。
              这些能量场可以与人体的能量场（或称气场）相互作用，影响我们的身体、情绪和精神状态。
            </p>
            <p className="mt-4">
              在能量学理论中，人体有七个主要的能量中心，称为脉轮（Chakras）。
              不同的水晶可以与特定的脉轮共振，帮助平衡和激活这些能量中心。
              例如，紫水晶与顶轮（第七脉轮）相关，有助于增强灵性意识；
              而红玉髓则与根脉轮（第一脉轮）相关，提供稳定和安全感。
            </p>
          </section>
          
          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">常见水晶及其特性</h2>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">
              <div className="card p-4">
                <h3 className="text-xl font-medium mb-2">紫水晶</h3>
                <p>
                  紫水晶被称为"灵性石"，有助于净化负面能量，增强直觉和灵性意识。
                  它与顶轮相连，促进冥想和高级意识的发展。在科学上，紫水晶是石英的一种变体，
                  其紫色来源于铁离子的存在。
                </p>
              </div>
              
              <div className="card p-4">
                <h3 className="text-xl font-medium mb-2">粉晶</h3>
                <p>
                  粉晶被称为"爱的石头"，能够打开心轮，促进自爱和人际关系的和谐。
                  它有助于疗愈情感创伤，吸引爱情，增强同理心。粉晶是石英家族的一员，
                  其粉红色来源于微量的锰和钛。
                </p>
              </div>
              
              <div className="card p-4">
                <h3 className="text-xl font-medium mb-2">黄水晶</h3>
                <p>
                  黄水晶与太阳能量相连，能够激活太阳神经丛脉轮，带来丰盛、自信和创造力。
                  它是财富和成功的象征。黄水晶是石英的一种变体，其黄色来源于铁离子。
                  许多市场上的黄水晶实际上是经过热处理的紫水晶。
                </p>
              </div>
              
              <div className="card p-4">
                <h3 className="text-xl font-medium mb-2">白水晶</h3>
                <p>
                  白水晶是能量放大器，能够净化和平衡所有脉轮。它增强意念力，提高冥想效果，
                  是最全能的水晶之一。白水晶是二氧化硅的结晶体，是地球上最丰富的矿物之一。
                  其透明度取决于形成过程中的纯度。
                </p>
              </div>
              
              <div className="card p-4">
                <h3 className="text-xl font-medium mb-2">黑曜石</h3>
                <p>
                  黑曜石是强大的保护石，能够抵挡负面能量和精神攻击。它帮助揭示内在真相，
                  促进灵性成长和自我认知。黑曜石是火山玻璃，由熔岩快速冷却形成。
                  它不是真正的晶体，而是非晶质物质，主要成分是二氧化硅。
                </p>
              </div>
              
              <div className="card p-4">
                <h3 className="text-xl font-medium mb-2">月光石</h3>
                <p>
                  月光石与月亮能量相连，增强女性力量、直觉和创造力。它平衡情绪，
                  促进和谐与内在成长。月光石是长石家族的一员，其特殊的光泽（称为光彩效应）
                  是由内部结构散射光线造成的。
                </p>
              </div>
            </div>
          </section>
          
          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">水晶的选择与使用</h2>
            <p>
              选择水晶时，最重要的是倾听自己的直觉。你可能会被某种水晶特别吸引，
              这通常意味着这种水晶的能量是你当前所需要的。你也可以根据自己的需求和目标选择水晶，
              例如，如果你希望增强自信，可以选择黄水晶；如果你希望促进爱与和谐，可以选择粉晶。
            </p>
            <p className="mt-4">
              水晶可以通过多种方式使用：
            </p>
            <ul className="list-disc pl-6 mt-2">
              <li>佩戴水晶首饰，让水晶能量直接与你的能量场互动</li>
              <li>在冥想时手持水晶或将水晶放置在相应的脉轮位置</li>
              <li>在家中或办公室摆放水晶，净化和平衡空间能量</li>
              <li>制作水晶网格，创造特定的能量场用于特定目的</li>
              <li>将水晶放在枕头下或床边，影响梦境和睡眠质量</li>
            </ul>
          </section>
          
          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">水晶的清洁与充能</h2>
            <p>
              水晶会吸收和存储能量，因此定期清洁和充能非常重要。清洁水晶可以去除累积的负面能量，
              而充能则可以恢复和增强水晶的自然能量。
            </p>
            <p className="mt-4">
              清洁水晶的方法包括：
            </p>
            <ul className="list-disc pl-6 mt-2">
              <li>流水冲洗：将水晶放在流动的水下冲洗几分钟</li>
              <li>月光浴：在满月之夜将水晶放置在月光下</li>
              <li>阳光浴：将水晶放在阳光下（注意某些水晶如紫水晶可能会褪色）</li>
              <li>烟熏：使用鼠尾草或其他净化草药的烟熏水晶</li>
              <li>声音净化：使用音叉、钵或铃铛的声音振动净化水晶</li>
            </ul>
          </section>
          
          <div className="mt-8 text-center">
            <Link
              to="/category"
              className="inline-block bg-primary text-white px-6 py-3 rounded-md hover:bg-primary-dark transition-colors"
            >
              浏览逸流珠宝
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutCrystals;